import get from 'lodash/get'
import { connect } from 'react-redux'
import { changeClanAttributes } from '../Actions/ActionClanEdit'
import { closeRecommendationsDialog } from '../Actions/ActionClanProfile'
import { hideDialog } from '../Actions/ActionDialog'
import { ClanRecommendationsSettings, getClanRecommendationsSettings, setClanRecommendationsSettings } from '../Actions/ActionRecommendations'
import ClanSettingsDialog from '../Components/ViewRecommendations/ClanSettingsDialog/ClanSettingsDialog'
import * as web2ClientAPI from '../web2ClientAPI/web2ClientAPI'

const mapStateToProps = (state) => {
  const currentAccountClanId = state.currentAccount.clanId
  const clanData = state.clans.items[currentAccountClanId]

  return {
    isFetching: get(state.clanEdit, 'clanDescription.isFetching', false),
    descriptionError: get(state.clanEdit, 'clanDescription.message', ''),
    clanSettings: state.ReducerRecommendations.clanSettings,
    clanData,
  }
}

const mapDispatchToProps = (dispatch, ownProps) => ({
  hideDialog: () => {
    dispatch(hideDialog())
    dispatch(closeRecommendationsDialog())
  },
  updateSettings: (clanRecommendationsSettings: ClanRecommendationsSettings, description: String) => {
    dispatch(setClanRecommendationsSettings(clanRecommendationsSettings))

    const clanData = ownProps.clanData
    dispatch(changeClanAttributes({ ...clanData, description, rawDescription: description }, true)).then((isSuccess) => {
      isSuccess && dispatch(hideDialog())
      isSuccess && dispatch(closeRecommendationsDialog())
      web2ClientAPI.sendClanRecommendationCompleteNotification()
    })

  },
  loadSettings: () => {
    dispatch(getClanRecommendationsSettings())
  },
})

export default connect(mapStateToProps, mapDispatchToProps)(ClanSettingsDialog)